import React from "react";
import WatermarkedMedia from "./WatermarkedMedia";
import Editable from "./Editable";

export const About = ({ data = {}, editable, onChange, onMediaClick }) => {
  const setField = (k, v) => onChange && onChange({ ...data, [k]: v });
  const stats = data.stats || [];
  const setStat = (i, key, v) => {
    const next = stats.map((s, idx) => (idx === i ? { ...s, [key]: v } : s));
    setField("stats", next);
  };

  return (
    <section id="about" className="relative bg-onyx-900 py-28 md:py-36" data-testid="about-section">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 md:px-10 lg:grid-cols-2 lg:gap-20">
        <div className="relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <WatermarkedMedia
              src={data.image_url}
              alt="Dhadda Motion Pictures team"
              position="bottom-right"
              opacity={0.85}
              watermarkSize={56}
              className="h-full w-full"
              testId="about-image"
            />
            {editable && (
              <button
                onClick={onMediaClick}
                className="absolute top-4 left-4 font-cinzel text-[10px] tracking-[0.3em] uppercase text-onyx-900 bg-gold hover:bg-gold-bright px-4 py-2"
                data-testid="about-edit-media-btn"
              >
                Replace Image
              </button>
            )}
          </div>
          {/* Decorative accent */}
          <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-gold/40 -z-0 hidden md:block" />
        </div>

        <div className="flex flex-col justify-center">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-10 bg-gold" />
            <Editable
              editable={editable}
              value={data.eyebrow}
              onChange={(v) => setField("eyebrow", v)}
              className="font-cinzel text-[11px] tracking-[0.4em] uppercase text-gold"
              testId="about-eyebrow"
            />
          </div>

          <Editable
            as="h2"
            editable={editable}
            value={data.title}
            onChange={(v) => setField("title", v)}
            className="font-display text-4xl md:text-5xl lg:text-6xl text-ivory leading-[1.05]"
            testId="about-title"
          />

          <Editable
            as="p"
            multiline
            editable={editable}
            value={data.body}
            onChange={(v) => setField("body", v)}
            className="mt-8 text-ivory/70 leading-relaxed text-base md:text-lg"
            testId="about-body"
          />

          <div className="mt-12 grid grid-cols-2 gap-8 border-t border-gold/15 pt-10">
            {stats.map((s, i) => (
              <div key={s.label || `stat-${i}`} data-testid={`about-stat-${i}`}>
                <Editable
                  editable={editable}
                  value={s.value}
                  onChange={(v) => setStat(i, "value", v)}
                  className="font-display text-4xl md:text-5xl text-gold-gradient block"
                />
                <Editable
                  editable={editable}
                  value={s.label}
                  onChange={(v) => setStat(i, "label", v)}
                  className="mt-2 font-cinzel text-[10px] tracking-[0.25em] uppercase text-ivory/55 block"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
